export default "__VITE_ASSET__vNdIp9H9__"